import * as React from 'react';

import Icon from 'components/atoms/Icon';

export type KnobTypeProps = '' | 'disabled' | 'like';
export type KnobSizes = 'xs' | 's' | 'm' | 'l' | 'xl' | 'xxl';
export type KnobIcons =
	| 'arrow-right'
	| 'arrow-left'
	| 'arrow-twin-left'
	| 'back'
	| 'calendar'
	| 'close'
	| 'completed'
	| 'heart'
	| 'play'
	| 'plus'
	| 'close'
	| 'solid'
	| 'question-mark'
	| 'start'
	| 'restart'
	| 'pause';

export type KnobProps = {
	onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
	type?: KnobTypeProps;
	modifier?: string;
	size: KnobSizes;
	icon: KnobIcons | string;
	attributes?: {
		[key: string]: any;
	};
	_class?: string;
	disabled?: boolean;
	loading?: boolean;
};

const Knob = ({
	icon,
	size,
	modifier,
	onClick,
	type,
	attributes = {},
	disabled = false,
	loading = false,
}: KnobProps) => {
	const createClassList = () => {
		return `a-knob${modifier ? ` a-knob--${modifier}` : ''}${size ? ` a-knob--${size}` : ''}${
			type ? ` state-a-knob--${type}` : ''
		}${disabled ? ' state-a-knob--disabled' : ''}${loading ? ' state-a-knob--loading' : ''}`;
	};

	if (disabled || loading) {
		attributes.disabled = true;
	}
	return (
		<button onClick={onClick} className={createClassList()} type="button" {...attributes}>
			<Icon iconName={icon} />
		</button>
	);
};

export default Knob;
